export default __webpack_public_path__ + "static/icon-9-3-61447cb35dc1352293a0d49f48efd551.png";